import { CURRENT_YEAR_MAX_DATE, MAX_DATE, MIN_DATE } from "../components/AppToolbar";
import { EnviromentType } from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/EnvironmentService";
import { Routes } from "../types/Routes";
import environment from "../environment.json";

/**
 * Validates the search parameters based on specific criteria.
 * @param searchParams - The URLSearchParams object containing the search parameters.
 * @returns A boolean indicating whether the search parameters are valid or not.
 */
const validateSearchParams = (searchParams: URLSearchParams, allowFutureYears: boolean): boolean => {
  for (const [key, value] of searchParams.entries()) {
    if (key === "project" || key === "user") {
      if (!(value.length <= 0) && !isValidUUIDValue(value) && environment.type !== EnviromentType.DEV) {
        return false;
      }
    } else {
      if (!validateParams(key, value, allowFutureYears)) {
        return false;
      }
    }
  }

  return true;
};

/**
 * Checks if a month value is valid.
 * @param month - The month value to validate.
 * @returns A boolean indicating whether the month value is valid or not.
 */
const isValidMonthValue = (month: number): boolean => {
  return Number(month) >= 0 && Number(month) <= 12;
};

/**
 * Checks if a year value is valid.
 * @param year - The year value to validate.
 * @returns A boolean indicating whether the year value is valid or not.
 */
const isValidYearValue = (year: number, maxYear: number): boolean => {
  return Number(year) >= MIN_DATE.getFullYear() && Number(year) <= maxYear;
};

/**
 * Checks if a UUID value is valid.
 * @param uuid - The UUID value to validate.
 * @returns A boolean indicating whether the UUID value is valid or not.
 */
const isValidUUIDValue = (uuid: string): boolean => {
  const maxLength = 32;
  const regex = new RegExp(`^[a-zA-Z0-9]{1,${maxLength}}$`);
  return regex.test(uuid);
};

/**
 * Validates specific parameters based on their keys and values.
 * @param key - The parameter key.
 * @param value - The parameter value.
 * @returns A boolean indicating whether the parameter is valid or not.
 */
const validateParams = (key: string, value: string, allowFutureYears: boolean) => {
  if (key === "month" && !isNaN(parseInt(value))) {
    return isValidMonthValue(parseInt(value));
  }

  if (key === "year" && !isNaN(parseInt(value))) {
    return isValidYearValue(parseInt(value), allowFutureYears ? MAX_DATE.getFullYear() : CURRENT_YEAR_MAX_DATE.getFullYear());
  }

  return true;
};

export const routesAllowedForFutureYears = [
  Routes.TIME_OFF,
  Routes.ASSIGNATION_PROJECTION,
  Routes.OVER_STAFF_REPORT,
  Routes.TIME_OFF_REPORT,
  Routes.VACATION_REPORT,
  Routes.WORKLOG,
  Routes.UNIFIED_REPORTS,
];

export { validateSearchParams };
